/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {AdminResourceContextRoutePageComponent} from '../common/controller/admin-resource-context-route-page.component';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {adminResourceItemRouteResolve} from '../common/controller/admin-resource-routing';
import {PERMISSIONS} from '../../components/auth/auth-constants';
import _ from 'lodash';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {AdvertiserResource} from '../../components/api/resources/resource/advertiser.resource';
import {OrderResource} from '../../components/api/resources/resource/order.resource';



export function advertiserStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('advertisers.advertiser', AdvertiserResource, OrderResource, 'app.adv', 'app', '<adn-advertiser-list-page [list]="list"></adn-advertiser-list-page>');
        $stateProvider.state(rh.listPath(), rh.list({
          resolve: {
            extension: /*@ngInject*/ function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return {
                func: function(ctrl, afterFill) {
                  if (afterFill) {
                    return;
                  }
                  ctrl.advertiserFields = ['name', 'url', {param: 'OwnerTeam', label: 'team'}];
                  if ((LocalNetworkInfo.obtain().getSuppInfo('elections') || []).length > 0) {
                    ctrl.advertiserFields.push('type');
                  }
                  ctrl.advertiserFields = ctrl.advertiserFields.concat({param: 'externalReference', label: 'extReference'}, 'contact', 'phone', 'email');
    
                  if (LocalNetworkProfile.isPureMarketplacePlatform()) {
                    ctrl.advertiserFields.push({param: 'bidInLastDay', label: 'status'});
                    ctrl.advertiserFields.push({param: '(last24HourDeliveryStats).impressionDelivery', label: 'impressionDelivery24', numeric: true});
                    ctrl.advertiserFields.push({param: '(last24HourDeliveryStats).renderedDelivery', label: 'renderedDelivery24', numeric: true});
                    ctrl.advertiserFields.push({param: '(last24HourDeliveryStats).viewableDelivery', label: 'viewableDelivery24', numeric: true});
                    ctrl.advertiserFields.push({param: '(last24HourDeliveryStats).clickDelivery', label: 'clickDelivery24', numeric: true});
                    ctrl.advertiserFields.push({param: '(last24HourDeliveryStats).spendDelivery', label: 'spendDelivery24', numeric: true});
                    ctrl.advertiserFields.push({param: '(last24HourDeliveryStats).viewability', label: 'viewability24', numeric: true});
                    ctrl.advertiserFields.push({param: '(last24HourDeliveryStats).ctr', label: 'ctr24', numeric: true});
    
                    ctrl.advertiserFields.push({param: '(last7DayDeliveryStats).impressionDelivery', label: 'impressionDelivery7', numeric: true});
                    ctrl.advertiserFields.push({param: '(last7DayDeliveryStats).renderedDelivery', label: 'renderedDelivery7', numeric: true});
                    ctrl.advertiserFields.push({param: '(last7DayDeliveryStats).viewableDelivery', label: 'viewableDelivery7', numeric: true});
                    ctrl.advertiserFields.push({param: '(last7DayDeliveryStats).clickDelivery', label: 'clickDelivery7', numeric: true});
                    ctrl.advertiserFields.push({param: '(last7DayDeliveryStats).spendDelivery', label: 'spendDelivery7', numeric: true});
                    ctrl.advertiserFields.push({param: '(last7DayDeliveryStats).viewability', label: 'viewability7', numeric: true});
                    ctrl.advertiserFields.push({param: '(last7DayDeliveryStats).ctr', label: 'ctr7', numeric: true});
                  }
    
                  const skipForDefaults = ['type', 'phone', 'email', 'contact', 'impressionDelivery24', 'impressionDelivery7', 'viewableDelivery24', 'clickDelivery24', 'viewability24',
                    'clickDelivery7', 'viewableDelivery7', 'viewability7', 'ctr7', 'ctr24'];
                  ctrl.defaultFields = _.filter(ctrl.advertiserFields, function(f) {
                    return skipForDefaults.indexOf(f.label || f.param || f) < 0;
                  });
                  ctrl.sel = {};
                  ctrl.perms = LocalUserPermissions.getAllVisPermissions();
    
                  ctrl.applyLimitedFilter = function() {
                    ctrl.limitedFilter = true;
                  };
                }
              };
            },
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasAny(PERMISSIONS.manageAdvertising.apiKey)
                && !LocalUserPermissions.hasNetworkPermission(PERMISSIONS.axAdvertiserAdmin.apiKey)
                && !LocalUserPermissions.hasAny(PERMISSIONS.axAdvertiserTeamAdmin.apiKey);
            }
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: _.merge({}, adminResourceItemRouteResolve('advertiser-item', 'item')),
            views: {
              'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
              'context@app': {component: AdminResourceContextRoutePageComponent}
            }
          }, 'Advertiser'));
  }, adnRouterHelper);
}
